// src/components/FlowResumeFrameWrapper.tsx
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { apiService } from '../utils/api';
import { setActiveFlowId } from '../utils/activeFlow';
import { flowIdForFrame, isSummaryFrame } from '../utils/frameFlowMap';

function extractFrameNumber(pathname: string): number | null {
  const m = pathname.match(/\/frame-(\d+)/);
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isInteger(n) ? n : null;
}

export default function FlowResumeFrameWrapper({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  useEffect(() => {
    const frameNumber = extractFrameNumber(location.pathname);
    if (frameNumber === null) return;

    const flowId = flowIdForFrame(frameNumber);
    if (!flowId) return;

    // Keep active flow aligned for refresh/deep-linking
    setActiveFlowId(flowId);

    // ✅ Critical: don't let summaries overwrite last "work" frame
    if (isSummaryFrame(flowId, frameNumber)) return;

    apiService
      .request(`/api/flows/${flowId}/progress`, {
        method: 'POST',
        body: JSON.stringify({ lastFrame: frameNumber }),
      })
      .catch((err) => {
        console.warn('[flow-resume] persist failed', { flowId, frameNumber, err });
      });
  }, [location.pathname]);

  return <>{children}</>;
}
